import {RadioProps} from "antd/lib/radio/interface";
import locales from "../../locales";
import {AppColors} from "../../statistics/utils/colors";
import {OptionProps} from "antd/lib/select";
import {numberGroupFormatter} from "../../utils/number-utils";

export enum ChecklistOption {
  TRUE = "YES",
  FALSE = "NO",
  NOT_APPLICABLE = "NOT_APPLICABLE",
}

const checklistYesNoOptionColorMap: Map<string, string|undefined> = new Map([
  [ChecklistOption.TRUE, undefined],
  [ChecklistOption.FALSE, AppColors.RED],
  [ChecklistOption.NOT_APPLICABLE, AppColors.MEDIUM_GRAY],
]);

export const mapChecklistYesNoOptionColor = (key: string): string | undefined => {
  return checklistYesNoOptionColorMap.get(key.toUpperCase());
}

const checklistNoYesOptionColorMap: Map<string, string|undefined> = new Map([
  [ChecklistOption.FALSE, undefined],
  [ChecklistOption.TRUE, AppColors.RED],
]);

export const mapChecklistNoYesOptionColor = (key: string): string | undefined => {
  return checklistNoYesOptionColorMap.get(key.toUpperCase());
}

export const checklistYesNoNotApplicableOptions: RadioProps[] = [{
  name: locales.checklist_option_true,
  value: ChecklistOption.TRUE,
}, {
  name: locales.checklist_option_false,
  value: ChecklistOption.FALSE,
}, {
  name: locales.checklist_option_not_applicable,
  value: ChecklistOption.NOT_APPLICABLE,
}];

export const checklistNoYesOptions: RadioProps[] = [{
  name: locales.checklist_option_false,
  value: ChecklistOption.FALSE,
}, {
  name: locales.checklist_option_true,
  value: ChecklistOption.TRUE,
}];

export const checklistYesNoOptionTextMap = {
  [ChecklistOption.TRUE]: locales.checklist_option_true,
  [ChecklistOption.FALSE]: locales.checklist_option_false,
  [ChecklistOption.NOT_APPLICABLE]: locales.checklist_option_not_applicable,
};

export const FuelType = {
  EMPTY: 'EMPTY',
  QUARTER: 'QUARTER',
  HALF: 'HALF',
  THREE_QUARTER: 'THREE_QUARTER',
  FULL: 'FULL',
};

export const fuelTypeToText = {
  [FuelType.EMPTY]: locales.fuel_empty,
  [FuelType.QUARTER]: locales.fuel_quarter,
  [FuelType.HALF]: locales.fuel_half,
  [FuelType.THREE_QUARTER]: locales.fuel_three_quarter,
  [FuelType.FULL]: locales.fuel_full,
};

export function getFuelTypeOptions(): OptionProps[] {
  return Object.keys(FuelType)
    .map(type => ({value: type, key: type, title: fuelTypeToText[type]}));
}

export const operationHoursFormatter = (value: number | string | undefined): string => {
    return `${numberGroupFormatter(value?.toString().replace(/[^\d.-]/g, ''))} ${locales.hours}`
};

export const operationHoursParser = (value: string | undefined): string=> {
    return value?.replace(`${locales.hours}`, '') ?? '';
};


export const checklistPropertyNameMap: Map<string, ChecklistTypedProperty> = new Map([
  ["operation_hours", {name: locales.checklistPropertyOperatingHours, type: 'operationHours'}],
  ["hydraulic_oil", {name: locales.checklistPropertyHydraulicOil, type: 'yesNo'}],
  ["hydraulic_system", {name: locales.checklistPropertyHydraulicSystem, type: 'yesNo'}],
  ["electronic_system", {name: locales.checklistPropertyElectronicSystem, type: 'yesNo'}],
  ["gauges", {name: locales.checklistPropertyGauges, type: 'yesNo'}],
  ["lights", {name: locales.checklistPropertyLights, type: 'yesNo'}],
  ["engine", {name: locales.checklistPropertyEngine, type: 'yesNo'}],
  ["body", {name: locales.checklistPropertyBody, type: 'yesNo'}],
  ["drive", {name: locales.checklistPropertyDrive, type: 'yesNo'}],
  ["safety", {name: locales.checklistPropertySafety, type: 'yesNo'}],
  ["wheels", {name: locales.checklistPropertyWheels, type: 'yesNo'}],
  ["brakes", {name: locales.checklistPropertyBrakes, type: 'yesNo'}],
  ["greasing", {name: locales.checklistPropertyGreasing, type: 'yesNo'}],
  ["dashboard", {name: locales.checklistPropertyDashboard, type: 'yesNo'}],
  ["windows", {name: locales.checklistPropertyWindows, type: 'yesNo'}],
  ["particle_filter", {name: locales.checklistPropertyParticleFilter, type: 'yesNo'}],
  ["error_codes", {name: locales.checklistPropertyErrorCodes, type: 'yesNo'}],
  ["adapters", {name: locales.checklistPropertyAdapters, type: 'yesNo'}],
  ["heating", {name: locales.checklistPropertyHeating, type: 'yesNo'}],
  ["fuel", {name: locales.checklistPropertyFuel, type: 'fuel'}],
  ["cleanliness", {name: locales.checklistPropertyCleanliness, type: 'yesNo'}],
  ["fire_extinguisher", {name: locales.checklistPropertyFireExtinguisher, type: 'yesNo'}],
  ["manual", {name: locales.checklistPropertyManual, type: 'yesNo'}],
  ["hand_greaser", {name: locales.checklistPropertyHandGreaser, type: 'yesNo'}],
  ["key", {name: locales.checklistPropertyKey, type: 'yesNo'}],
  ["changer_key", {name: locales.checklistPropertyChangerKey, type: 'yesNo'}],
]);

export const returnalExtraPropertyNameMap: Map<string, ChecklistTypedProperty> = new Map([
  ["report", {name: locales.checklistPropertyReportAfterReturnal, type: 'noYes'}],
  ["worksheet", {name: locales.checklistPropertyWorksheetAfterReturnal, type: 'noYes'}],
]);

export interface ChecklistTypedProperty {
  name: string;
  type: PropertyType;
}

export type PropertyType = 'yesNo' | 'fuel' | 'operationHours' | 'noYes';


// WEBPACK FOOTER //
// ./src/checklist/send/ChecklistTypes.tsx